module.exports = __webpack_public_path__ + "img/treehouse.de6a45fb.jpg";